// extracted by mini-css-extract-plugin
export default {"home_page":"HomePage_home_page__6z7KW","main":"HomePage_main__Eov3G","search_form":"HomePage_search_form__9P8ZQ","side":"HomePage_side__tPeTV"};